import axios from "axios";
import appconfig from "../../../AppConfig";
import { debug } from "../../../common/utils";
import { UPDATE_PICTURE_INFO } from "../pictures.actions";

export const updatePictureInfoApi = async (
  dispatch: any,
  pictureId: number,
  title: string,
  sizeX: number,
  sizeY: number,
  category: number
): Promise<boolean> => {
  const url = "products/updatePictureInfo";
  const data = {
    id: pictureId,
    title,
    sizeX,
    sizeY,
    category,
  };
  var result = false;

  const config = {
    baseURL: appconfig.baseURL,
  };

  await axios
    .post(url, data, config)
    .then((response: any) => {
      debug("!!! API - updatePictureInfoApi !!!");

      if (response && response.data) {
        dispatch({
          type: UPDATE_PICTURE_INFO,
          pictureId,
          title,
          sizeX,
          sizeY,
          category,
        });
        result = true;
      }

      debug(response);
    })
    .catch((err) => {
      console.log(err);
    });

  return result;
};
